// Advisor view, performance and transcript-backed audits (WA-09).
// Import helpers from './route-def.js' and schemas from api-audits.ts.
import * as U from './api-audits.js';
import { IdParam, items, route, W, Ws } from './route-def.js';

const AuditParam = W({ auditId: IdParam });

export const auditRoutes = {
  getAdvisorPerformance: route({
    method: 'GET', path: '/workspaces/:workspaceId/advisors/performance', summary: 'Desempeño por asesor (gerentes: todos; asesores: solo el propio)', tag: 'advisors',
    minRole: 'advisor', params: Ws, query: U.AdvisorPerformanceQuerySchema, response: U.AdvisorPerformanceSchema,
  }),
  getMyWork: route({
    method: 'GET', path: '/workspaces/:workspaceId/advisors/me/work', summary: 'Mi trabajo: conversaciones, transferencias, visitas y prospectos asignados', tag: 'advisors',
    minRole: 'advisor', params: Ws, response: U.MyWorkSchema,
  }),
  getAuditConfig: route({
    method: 'GET', path: '/workspaces/:workspaceId/audits/config', summary: 'Rúbrica vigente, muestreo y estado de la IA para auditorías', tag: 'advisors',
    minRole: 'advisor', params: Ws, response: U.AuditConfigSchema,
  }),
  updateAuditRubric: route({
    method: 'PUT', path: '/workspaces/:workspaceId/audits/rubric', summary: 'Editar la rúbrica (nueva versión; auditado)', tag: 'advisors',
    minRole: 'admin', params: Ws, body: U.UpdateAuditRubricSchema, response: U.AuditConfigSchema,
  }),
  updateAuditSampling: route({
    method: 'PUT', path: '/workspaces/:workspaceId/audits/sampling', summary: 'Configurar auditorías programadas por asesor y semana (auditado)', tag: 'advisors',
    minRole: 'admin', params: Ws, body: U.AuditSamplingSchema, response: U.AuditConfigSchema,
  }),
  listAuditCandidates: route({
    method: 'GET', path: '/workspaces/:workspaceId/audits/candidates', summary: 'Conversaciones atendidas por asesores que se pueden auditar', tag: 'advisors',
    minRole: 'manager', params: Ws, query: U.AuditCandidatesQuerySchema, response: items(U.AuditCandidateSchema),
  }),
  listAdvisorAudits: route({
    method: 'GET', path: '/workspaces/:workspaceId/audits', summary: 'Auditorías de asesores (asesores: solo las propias)', tag: 'advisors',
    minRole: 'advisor', params: Ws, query: U.AuditListQuerySchema, response: U.AuditListSchema,
  }),
  createAdvisorAudit: route({
    method: 'POST', path: '/workspaces/:workspaceId/audits', summary: 'Auditar una conversación o llamada atendida por un asesor (se evalúa en segundo plano)', tag: 'advisors',
    minRole: 'manager', params: Ws, body: U.CreateAdvisorAuditSchema, response: U.AdvisorAuditDetailSchema, status: 202,
  }),
  getAdvisorAudit: route({
    method: 'GET', path: '/workspaces/:workspaceId/audits/:auditId', summary: 'Detalle de una auditoría con evidencia', tag: 'advisors',
    minRole: 'advisor', params: AuditParam, response: U.AdvisorAuditDetailSchema,
  }),
  reviewAdvisorAudit: route({
    method: 'POST', path: '/workspaces/:workspaceId/audits/:auditId/review', summary: 'Revisar y corregir una auditoría (conserva el original; auditado)', tag: 'advisors',
    minRole: 'manager', params: AuditParam, body: U.ReviewAdvisorAuditSchema, response: U.AdvisorAuditDetailSchema,
  }),
  acknowledgeAdvisorAudit: route({
    method: 'POST', path: '/workspaces/:workspaceId/audits/:auditId/acknowledge', summary: 'El asesor confirma que leyó su auditoría', tag: 'advisors',
    minRole: 'advisor', params: AuditParam, response: U.AdvisorAuditDetailSchema,
  }),
} as const;
